export class TableContextVersion {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "versionId",
            "baseName": "versionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "generatedAt",
            "baseName": "generatedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "generatedBy",
            "baseName": "generatedBy",
            "type": "string",
            "format": ""
        },
        {
            "name": "editedBy",
            "baseName": "editedBy",
            "type": "string",
            "format": ""
        },
        {
            "name": "editedAt",
            "baseName": "editedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "summary",
            "baseName": "summary",
            "type": "string",
            "format": ""
        },
        {
            "name": "reasons",
            "baseName": "reasons",
            "type": "Array<TableContextVersionReason>",
            "format": ""
        },
        {
            "name": "pendingColumns",
            "baseName": "pendingColumns",
            "type": "number",
            "format": ""
        },
        {
            "name": "latest",
            "baseName": "latest",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableContextVersion.attributeTypeMap;
    }
    constructor() {
    }
}
